import { createSelector } from "@reduxjs/toolkit"

export const selectMarket = createSelector(
  [
    (
      products: Map<
        string,
        {
          name: string
          description: string
          entity: string
          url: string
          vaults: string[]
        }
      >,
    ) => products,
    (_, vault: string) => vault,
  ],
  (products, vault) => {
    return [...(products?.entries() ?? [])].find(([, { vaults }]) =>
      vaults.includes(vault),
    )
  },
)
